import { driver } from "driver.js";
import "driver.js/dist/driver.css";

/**
 * Hook to manage the Learner Onboarding Tour
 * @returns {startTour: () => void}
 */
export const useLearnerTour = () => {
    const startTour = () => {
        const driverObj = driver({
            showProgress: true,
            animate: true,
            nextBtnText: 'Suivant',
            prevBtnText: 'Précédent',
            doneBtnText: 'Terminer',
            steps: [
                {
                    element: '#learner-hero',
                    popover: {
                        title: 'Bienvenue sur votre Espace !',
                        description: 'Ceci est votre tableau de bord. Ici, vous pouvez voir votre progression globale et vos statistiques.'
                    }
                },
                {
                    element: '#menu-item-mes-parcours',
                    popover: {
                        title: 'Vos Parcours',
                        description: 'Accédez à tous les cours et formations qui vous sont assignés.'
                    }
                },
                {
                    element: '#menu-item-messages',
                    popover: {
                        title: 'Messagerie',
                        description: 'Consultez vos emails et notifications importantes ici.'
                    }
                },
                {
                    element: '#menu-item-chat',
                    popover: {
                        title: 'Chat Communautaire',
                        description: 'Échangez en direct avec vos formateurs et les autres apprenants de votre groupe.'
                    }
                },
                {
                    element: '#menu-item-enquêtes',
                    popover: {
                        title: 'Enquêtes de Satisfaction',
                        description: 'Donnez votre avis sur les formations. Vos retours nous aident à nous améliorer.'
                    }
                },
                {
                    element: '#menu-item-évaluations',
                    popover: {
                        title: 'Vos Évaluations',
                        description: 'Consultez les résultats de vos quiz et exercices pratiques.'
                    }
                },
                {
                    element: '#menu-item-profil',
                    popover: {
                        title: 'Votre Profil',
                        description: 'Gérez vos informations personnelles et vos préférences.'
                    }
                },
                {
                    element: '#menu-item-report-problem',
                    popover: {
                        title: 'Besoin d\'aide ?',
                        description: 'Un souci technique ou une question ? Signalez-le nous ici directment.'
                    }
                },
                {
                    element: '#courses-section',
                    popover: {
                        title: 'Reprendre rapidement',
                        description: 'Retrouvez ici vos cours en cours et reprenez exactement là où vous vous êtes arrêté.'
                    }
                }
            ]
        });

        driverObj.drive();
    };

    return { startTour };
};
